import { createAction, props } from '@ngrx/store';
import { ReferenceConfigModel } from '@shared/data-access/models';

export const getCompanySelected = createAction('[Swich Company Loader] GET COMPANY SELECTED', props<{ companySelected: ReferenceConfigModel }>());
